import { useAtomValue } from 'jotai'
import React from 'react'

import {
  buildFiveSegmentsTableColumns,
  type FiveSegmentColumnKey,
} from '~/apps/ninesegsAnalyzer/utils/standardAnalysis'
import { type ColumnInfo } from '~/utils'

import { fiveSegmentHiddenColumnKeysAtom } from '../atoms'

export const useFiveSegmentsTableColumns =
  (): ColumnInfo<FiveSegmentColumnKey>[] => {
    const hiddenColumnKeys = useAtomValue(fiveSegmentHiddenColumnKeysAtom)

    return React.useMemo(
      () => buildFiveSegmentsTableColumns({ hiddenColumnKeys }),
      [hiddenColumnKeys],
    )
  }
